//发端
const outList = {
  conn_permit_check: '接收端防骚扰验证',
  request_receiver_before: '发送端发起连接前',
  request_receiver_after: '发送端发起连接后',
  request_receiver_live_status: '询问接收端是否在房间中',
  request_receiver_create_group_before: '通知接收端创建房间动作开始',
  request_receiver_create_group_after: '通知接收端创建房间动作结束',
  request_lebocloud_join_group_before: '请求乐播云加入房间动作开始',
  request_lebocloud_join_group_after: '请求乐播云加入房间动作结束',
  request_zego_join_rtc_before: '请求即构加入房间动作开始',
  request_zego_join_rtc_after: '请求即构加入房间动作结束',
  request_zego_join_zim_before: '请求加入即构ZIM动作开始',
  request_zego_join_zim_after: '请求加入即构ZIM动作结束',
  request_vrviu_join_desktop_before: '请求云桌面动作开始',
  request_vrviu_join_desktop_after: '请求云桌面动作结束',
  request_lebocloud_upload_file_before: '上传文件动作开始',
  request_lebocloud_upload_file_after: '上传文件动作结束',
  request_lebocloud_generate_url_before: '请求乐播云生成文件在线地址动作开始',
  request_lebocloud_generate_url_after: '请求乐播云生成文件在线地址动作结束',
  request_appcloud_load_file_before: '通知云应用加载文档动作开始',
  request_appcloud_load_url_before: '通知云应用加载网址资源动作开始',
  cast_leave_after: '结束投屏事件',
  cast_on_timer: '投屏定时上报事件',
  button_click: '按钮点击事件',
  app_init_result: 'APP初始化',
  app_login: '会员登陆点击按钮后',
  app_lookup: '向乐播云询问接收端信息',
  page_leave: '页面跳转离开事件',
  button_result: '按钮点击结果事件',
}
//收端
const receiveList = {
  receiver_accept	:'收到连接请求',
  response_receiver_live_status:'响应发端是否在房间的询问',
  request_lebocloud_create_group_before	:'请求乐播云创建房间动作开始',
  request_lebocloud_create_group_after	:'请求乐播云创建房间动作结束',
  request_lebocloud_join_group_before	:'请求乐播云加入房间动作开始',
  request_lebocloud_join_group_after	:'请求乐播云加入房间动作结束',
  request_zego_join_rtc_before	:'请求即构加入房间动作开始',
  request_zego_join_rtc_after	:'请求即构加入房间动作结束',
  request_zego_join_zim_before	:'接收端请求加入即构ZIM动作开始',
  request_zego_join_zim_after	:'请求加入即构ZIM动作结束',
  request_vrviu_join_desktop_before	:'请求云桌面动作开始',
  request_vrviu_join_desktop_after	:'请求云桌面动作结束',
  cast_leave_after:	'结束投屏事件',
  cast_on_timer	:'投屏定时上报事件',
}
//乐播云
const appList = {join_group_after:'加入讨论房间', exit_group_after:'关闭讨论房间',cloud_event:'创建讨论房间' }
//云应用
const cloudList = {
  request_zego_join_rtc_before:'请求加入即构RTC动作开始',
  request_zego_join_rtc_after:'请求加入即构RTC动作结束',
  request_zego_join_zim_before:'请求加入即构ZIM动作开始',
  request_zego_join_zim_after:'请求加入即构ZIM动作结束',
  response_cast_file_before:'响应加载文档请求并开始加载',
  response_cast_file_after:'加载文档动作结束',
  response_appcloud_load_url_before:'收到加载网址资源请求并开始加载',
  response_appcloud_load_url_after:'加载网址资源动作结束',
  full_screen_click:'按钮点击-进入全屏',
  full_screen_exit:'按钮点击-退出全屏',
  broadcast_control:'按钮点击-播控操作',
  cast_on_timer:'投屏定时上报事件',
  app_exit:'云应用退出事件',
  app_error:'云应用异常事件',
}


export default {...outList, ...receiveList, ...appList, ...cloudList}
